define('modules/campaign/chart/views/dimensionsMenu',["T1", "T1View", "text!../templates/dimensionsMenu.html"], function (T1, T1View, template) {
  "use strict";

  const T1Publish = T1.EventHub.publish;
  return T1View.extend({
    template: template,
    events: {
      "changed .dimensions-ddl": "viewByChangeHandler"
    },
    initialize: function (configs = {}) {
      this.id = configs.id || 0;
      this.default = configs.default || "Select One";
      this.selected = configs.selected || "";
      this.dimensions = (configs.dimensions instanceof Function ? configs.dimensions() : configs.dimensions) || [];
      this.maxItems = configs.maxItems || "";
      this.overflow = configs.overflow || "hidden";
      this.overflowWidth = configs.overflowWidth || 0;
    },
    load: function () {
      this.render().then(function () {
        T1Publish("complete:layoutLoad");
      });
    },
    unload: function () {
      this.default = null;
      this.dimensions = null;
      this.id = null;
      this.maxItems = null;
      this.overflow = null;
      this.overflowWidth = null;
      this.selected = null;
    },
    viewByChangeHandler: function (event) {
      T1Publish("change:viewBy", {
        id: this.id,
        value: event.originalEvent.detail.value,
        label: event.currentTarget.$.label.innerText
      });
    },
    serialize: function () {
      return {
        default: this.default,
        selected: this.selected,
        dimensions: this.dimensions,
        maxItems: this.maxItems,
        overflow: this.overflow,
        overflowWidth: this.overflowWidth
      };
    }
  });
});
